import React, { useState } from 'react';

const steps = [
  {
    id: 1,
    title: 'Select Profile',
    desc: 'Select a profile and support a child who is need of sponsorship.',
    icon: '🪪' // You can replace with your actual icon/image
  },
  {
    id: 2,
    title: 'View Expenditure',
    desc: 'Check the monthly expenditure on the education of the child.',
    icon: '💳'
  },
  {
    id: 3,
    title: 'Sponsor a Child',
    desc: 'It will take only few minutes of your time to fill out the sponsor form.',
    icon: '🤝'
  },
  {
    id: 4,
    title: 'Restore a Smile',
    desc: 'Your support will create a lasting and positive impact on a child.',
    icon: '🤗'
  }
];

const Stepper = () => {
  const [activeStep, setActiveStep] = useState(0);

  return (
    <div className="stepper-wrapper">
      <div className="stepper-container">
        {steps.map((step, idx) => (
          <div
            key={step.id}
            className={`step-card ${activeStep === idx ? 'active' : ''}`}
            onClick={() => setActiveStep(idx)}
          >
            <div className="step-number">
              {step.id}
            </div>
            <div className="step-icon">
              {step.icon}
            </div>
            <h3 className="step-title">{step.title}</h3>
            <p className="step-description">{step.desc}</p>
          </div>
        ))}
      </div>

      <style jsx>{`
        .stepper-wrapper {
          width: 100%;
          padding: 40px 20px;
          background: #d0efe1;
          border-radius: 20px;
        
        }

        .stepper-container {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 20px;
          max-width: 1200px;
          margin: 0 auto;
        }

        .step-card {
          background: white;
          border-radius: 20px;
          padding: 30px 20px;
          text-align: left;
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
          border: 3px solid transparent;
        }

        .step-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
        }

        .step-card.active {
          // border-color: #ffd700;
          // background: linear-gradient(135deg, #fff9e6 0%, #ffffff 100%);
        }

        .step-number {
          position: absolute;
          top: -15px;
          left: 20px;
          width: 40px;
          height: 40px;
          background: #2c3e50;
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 18px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
        }

        .step-card.active .step-number {
          background: #f39c12;
        }

        .step-icon {
          font-size: 48px;
          margin: 20px 10px;
          align-items: left;
          display: block;
        }

        .step-title {
          font-size: 20px;
          font-weight: 500;
          color: #264653;
          margin: 15px 0 10px 0;
          line-height: 1.3;
        }

        .step-description {
          font-size: 16px;
 justify-content: left;
 text-align: left;
          color: #264653;
          line-height: 1.5;
         
        }

        .step-card.active .step-title {
          color: #f39c12;
        }

        .step-card.active .step-description {
          color: #5d4e37;
        }

        /* Mobile Styles */
        @media (max-width: 768px) {
          .stepper-wrapper {
            padding: 20px 10px;
            margin: 10px 0;
            background: #fff;
          }

          .stepper-container {
            grid-template-columns: repeat(4, 280px);
            gap: 15px;
            overflow-x: auto;
            scroll-behavior: smooth;
            padding: 20px 10px 40px 10px;
            -webkit-overflow-scrolling: touch;
          }

          .stepper-container::-webkit-scrollbar {
            height: 0px;
          }

          .stepper-container::-webkit-scrollbar-track {
            background: transparent;
            border-radius: 0px;
          }

          .stepper-container::-webkit-scrollbar-thumb {
            background: transparent;
            border-radius: 0px;
          }

          .step-card {
            min-width: 260px;
            padding: 25px 15px;
              background: #d0efe1;
          }

          .step-number {
            width: 35px;
            height: 35px;
            font-size: 16px;
            top: -12px;
            left: 15px;
          }

          .step-icon {
            font-size: 40px;
            margin: 15px 0;
          }

          .step-title {
            font-size: 16px;
            margin: 12px 0 8px 0;
          }

          .step-description {
            font-size: 13px;
          }
        }

        @media (max-width: 480px) {
          .stepper-container {
            grid-template-columns: repeat(4, 240px);
            gap: 12px;
            padding: 15px 5px 35px 5px;
          }

          .step-card {
            min-width: 220px;
            padding: 20px 12px;
          }

          .step-number {
            width: 30px;
            height: 30px;
            font-size: 14px;
            top: -10px;
            left: 12px;
          }

          .step-icon {
            font-size: 36px;
            margin: 12px 0;
          }

          .step-title {
            font-size: 15px;
            margin: 10px 0 6px 0;
          }

          .step-description {
            font-size: 12px;
          }
        }
      `}</style>
    </div>
  );
};

export default Stepper;